<template>
  <div>
    <b-row
      ><b-col md="6"><h4>Download History</h4></b-col>
      <b-col md="3" style="margin-left: 63px">
        <eb-select
          style="background-color: #fff"
          id="text"
          type="text"
          label="text"
          :options="dateOption"
          v-model="selectedDate"
          :selected="selectedDate.text"
          @input="changeDate"
        >
        </eb-select>
        <b-modal
          title="Select Date"
          header-class="header-nipige-class"
          id="dateRange"
          size="sm"
          ref="date-range"
          centered
          hide-footer
        >
          <b-input class="mb-2" type="date" v-model="startDate"></b-input>
          <b-input type="date" v-model="endDate"></b-input>
          <div class="text-center mt-2">
            <b-button
              @click="findButtonClick()"
              class="my -0 main-navigation-button w-47 mr-2"
              variant="success"
              >Find
            </b-button>
          </div>
        </b-modal>
      </b-col>
      <b-col md="2"
        ><b-button
          variant="primary"
          class="ml-n3"
          style="width: 194px; height: 38px"
          @click="backBtn()"
          >VIEW {{ type }} REPORT</b-button
        ></b-col
      ></b-row
    >
    <b-table
      :dark="dark"
      :hover="hover"
      :striped="striped"
      :bordered="bordered"
      :small="small"
      :fixed="fixed"
      responsive="sm"
      thead-class="header"
      show-empty
      :fields="items"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :items="requestTable"
      @filtered="onFilter"
    >
      <template slot="status" slot-scope="data">
        <div v-if="data.item.status === 'COMPLETED'" style="color: green">
          {{ data.item.status }}
        </div>
        <div v-else style="color: orangered">
          {{ data.item.status }}
        </div>
      </template>
      <template slot="createdAt" slot-scope="data">{{
        data.item.createdAt | formatedate
      }}</template>
      <template slot="action" slot-scope="data">
        <div v-if="data.item.status === 'COMPLETED'">
          <a
            :href="`https://${data.item.url
              .replace('http://', '')
              .replace('https://', '')}`"
            class="text-dark"
            target="_blank"
          >
            <b-button variant="info" style="border-radius: 32px"
              ><i class="fa fa-download text-white" aria-hidden="true"></i
            ></b-button>
          </a>
        </div>
        <div v-else>
          <b-button variant="info" style="border-radius: 32px" disabled
            ><i class="fa fa-download text-white" aria-hidden="true"></i
          ></b-button>
        </div>
      </template>
    </b-table>
    <div style="float: right">
      <b-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total-rows="filterCount"
        aria-controls="my-table"
        prev-text="Prev"
        next-text="Next"
        hide-goto-end-buttons
      ></b-pagination>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
export default {
  components: {
    ebSelect,
  },
  data() {
    return {
      type: "",
      selectedDate: {
        text: "Today",
        value: 1,
      },
      dateOption: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 day's",
          value: 7,
        },
        {
          text: "30 day's",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      startDate: "",
      endDate: "",
      filterCount: 0,
      perPage: 10,
      currentPage: 1,
      filter: "",
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      items: [
        { key: "requestNo", label: "Request#" },
        { key: "createdAt", label: "Request Date", sortable: true },
        { key: "collectionName", label: "Request Type" },
        { key: "requestBy.name", label: "Requested By" },
        { key: "status", label: "Status" },
        { key: "action", label: "Action" },
      ],
    };
  },
  computed: {
    requestTable() {
      return this.$store.getters["partner/GetRequestDownload"];
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY");
      }
    },
  },
  methods: {
    findButtonClick() {
      let e = {
        fromDate: this.startDate,
        toDate: this.endDate,
      };
      this.$refs["date-range"].hide();
      this.fetchRequest();
    },
    changeDate(e) {
      this.selectedDate = e;
      if (e.value == "custom") {
        this.$refs["date-range"].show();
        return;
      }
      this.fetchRequest();
    },
    getDateData(dateData) {
      if (dateData == "custom") {
        const data = {
          fromDate: this.startDate,
          toDate: this.endDate,
        };
        return data;
      }
      if (dateData == 1) {
        const data = {
          fromDate: moment().format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        return data;
      } else {
        const data = {
          fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
          toDate: moment().format("YYYY-MM-DD"),
        };
        if (typeof dateData === "number") {
          data.fromDate = moment()
            .subtract(dateData - 1, "days")
            .format("YYYY-MM-DD");
          return data;
        } else if (typeof dateData === "object") {
          return dateData;
        }
        return data;
      }
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    fetchRequest() {
      const payload = {
        ...this.getDateData(this.selectedDate.value),
        type: this.$route.params.type,
        status: "",
      };
      this.$store.dispatch("partner/fetchRequest", payload);
    },
    backBtn() {
      if (this.$route.params.type === "CUSTOMER") {
        this.$router.push({ path: "/analytics/dailyRegistration" });
      } else {
        this.$router.push({ path: "/analytics/orderReport" });
      }
    },
  },
  mounted() {
    this.type = this.$route.params.type;
    this.fetchRequest();
  },
};
</script>